export enum ELogoSizes {
  PRINT = 'print',
  SQUARE = 'square',
  RECTANGULAR = 'rectangular',
}

export enum ELogoKeys {
  PRINT = 'PrintLogoFile',
  SQUARE = 'SquareLogoFile',
  RECTANGULAR = 'RectangularLogoFile',
}
